import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=45592a39&"
import script from "./publish.vue?vue&type=script&lang=ts&"
export * from "./publish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports